import React, { useContext, useEffect, useState } from "react";
import socket from "../../socket";
import "./SuperYantra_Controls.css";

import {
  findAll,
  ChangeResult,
} from "../../../src/utils/apis/superYantraManualResult/superYantraManualResult";
import { AllSymbol } from "../../utils/apis/common";
import { Select2Data, Select2Image } from "../../utils/common";
import { Context } from "../../utils/context";

function SuperYantra_Controls() {
  const [selectedSymbol, setSelectedSymbol] = useState(null);

  const [result, setResult] = useState("");
  const [bhingariTimer, setBhingariTimer] = useState(0);
  const [periodId, setPeriodId] = useState(null);
  console.log(periodId, "periodId");

  const [period, setPeriod] = useState(null);
  const [jokerManual, setJokerManual] = useState(false);
  const { UnauthorizedLogOut, IMG_URL, Select2Data } = useContext(Context);

  const [tableData, setTableData] = useState({
    data: {
      totals: {},
      grand_total: 0,
    },
  });

  console.log(tableData, "tableData");

  const [symbol, setSymbol] = useState([]);

  console.log(symbol, "symbol");

  const GetAllSymbol = async () => {
    const response = await AllSymbol();
    if (response?.data?.success) {
      setSymbol(await Select2Image(response?.data?.data, "symbol_id"));
    }
  };

  useEffect(() => {
    GetAllSymbol();
  }, []);

  const getTableData = async () => {
    try {
      const res = await findAll();

      console.log("Super Yantra API Response:", res);

      if (res?.success) {
        setTableData(res);
      } else if (res?.data) {
        setTableData(res);
      }
    } catch (error) {
      console.error("❌ findAll Error:", error);
    }
  };

  useEffect(() => {
    const handleYantraTimer = (data) => {
      console.log(data, "datadatadata");

      const timer = Number(data?.yantra_time || 0);

      setBhingariTimer(timer);
      setPeriodId(data?.period_id || null);
      setPeriod(data?.period || null);

      if (
        timer === 60 ||
        timer === 50 ||
        timer === 40 ||
        timer === 30 ||
        timer === 20 ||
        timer === 10
      ) {
        getTableData();
      }
    };

    socket.on("yantra_timer", handleYantraTimer);

    return () => {
      socket.off("yantra_timer", handleYantraTimer);
    };
  }, []);

  useEffect(() => {
    getTableData();
  }, []);

  const handleResult = async () => {
    if (result === "") {
      alert("Please Enter Result");
      return;
    }

    if (!periodId) {
      alert("Period Not Found");
      return;
    }

    const data = {
      manual_symbol_id: Number(selectedSymbol),
    };

    try {
      const res = await ChangeResult(periodId, data);

      console.log("ChangeResult Response:", res);

      if (res?.success) {
        alert("Result changed successfully");

        setResult("");
        setJokerManual(false);

        getTableData();
      }
    } catch (error) {
      console.error("❌ ChangeResult Error:", error);

      alert(error?.message || error?.error || "Failed to change result");
    }
  };

  return (
    <section className="View_List">
      {/* Period */}
      <div className="period-box">
        <strong>Period : {period || tableData?.data?.period || "-"}</strong>
      </div>

      {/* Symbol Bets */}
      <div className="numbers-wrapper">
        {Object.entries(tableData?.data?.data?.totals || {}).map(
          ([symbolName, amount]) => {
            const currentSymbol = symbol.find(
              (item) => Number(item.value) === Number(symbolName),
            );

            if (!currentSymbol) return null;

            const isActive =
              Number(selectedSymbol) === Number(currentSymbol.value);

            return (
              <div
                className={`number-box ${isActive ? "active" : ""}`}
                key={symbolName}
                onClick={() => {
                  setSelectedSymbol(currentSymbol.value);
                  setResult(currentSymbol.label);
                }}>
                {currentSymbol?.image && (
                  <img
                    src={"http://127.0.0.1:4252" + currentSymbol.image}
                    alt={currentSymbol.label}
                    className="symbol-image"
                  />
                )}

                <label className="num-label">{currentSymbol.label}</label>

                <h4 className="text text-danger">₹ {Number(amount || 0)}</h4>
              </div>
            );
          },
        )}
      </div>

      {/* Grand Total */}
      <div className="total-box">
        <strong>
          Total Bets: ₹ {Number(tableData?.data?.grand_total || 0)}
        </strong>
      </div>

      {/* Timer */}
      <strong>Timer : {String(bhingariTimer).padStart(2, "0")}</strong>

      {/* Result Section */}
      <div className="result-section row mt-4">
        <div className="col-md-2">
          <input
            type="text"
            className="result-input"
            placeholder="Select Symbol"
            value={result}
            readOnly
          />
        </div>

        <div className="col-md-4">
          {bhingariTimer <= 50 && bhingariTimer >= 5 ? (
            <button
              type="button"
              className="btn btn-success"
              onClick={handleResult}>
              Submit
            </button>
          ) : (
            <p style={{ color: "red" }}>
              Submit available only from 20 to 5 Seconds
            </p>
          )}
        </div>
      </div>
    </section>
  );
}

export default SuperYantra_Controls;
